import React, { useContext, useRef, useState, useEffect } from 'react'
import { motion } from 'framer-motion/dist/framer-motion'
import { Link } from 'react-router-dom'

import { DataContext } from '../../../Context/DataContext'

import './NotFound.scss'

import Section from '../../Section'
import Social from '../../Social'
import HomeLink from '../../HomeLink'

const drawWave = (color) => {
    return {
        hidden: () => { 
            return {
                pathLength: 0,
                fill: '#FFFFFF',
                fillOpacity: 0,
                stroke: '#FFFFFF',
                opacity: 0
            }
        },
        visible: (i) => {
            let stroke = color
            const strokeDelay = i * 0.5
            const fillDelay = strokeDelay + 0.5
            const transition = {
                pathLength: { delay: strokeDelay, duration: 1.5, ease: "easeInOut" },
                opacity: { delay: strokeDelay, duration: 0.1 },
                fillOpacity: { delay: fillDelay, duration: 1, ease: "easeInOut"},
                fill: { delay: fillDelay, duration: 1, ease: "easeInOut"},
            }
            return {
                pathLength: 1.1,
                fill: color,
                fillOpacity: 1,
                stroke,
                opacity: 1,
                pathOffset: 0,
                transition,
            }
        },
    }
}

const NotFound = () => {
    const { strings } = useContext(DataContext)
    const svgRef = useRef(null)
    const [ marginTop, setMarginTop ] = useState(0)

    useEffect(() => {
        if (svgRef.current) {
            setMarginTop(svgRef.current.clientHeight * 2)
        }
    }, [svgRef])

    return (
        <>
            <Section
                name="mga-404"
                className="mga-404-section"
                motionProps={{
                    initial: { opacity: 0 },
                    animate: { opacity: 1 },
                    exit: { opacity: 0 },
                    transition: { duration: 0.5 }
                }}
            >
                <HomeLink />
                <div
                    className="mga-404-section__main"
                    style={{
                        marginTop,
                    }}
                >
                    <motion.svg
                        ref={svgRef}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox='0 0 1363 66'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.1 }}
                        style={{ 
                            fillRule: "evenodd", 
                            clipRule: "evenodd", 
                            strokeLinejoin: "round", 
                            strokeMiterlimit: 2,
                            strokeWidth: 0.2
                        }}
                    >
                        <motion.path
                            d="M0 66.779s605.654-43.313 829.35-51.55S1363.371 0 1363.371 0v67.2z"
                            stroke="#E23B00"
                            fill="#FFFFFF"
                            variants={drawWave("#E23B00")}
                            initial="hidden"
                            animate="visible"
                            custom={1}
                            style={{
                                fillRule: "nonzero",
                            }}
                        />
                    </motion.svg>
                    <motion.div
                        className="mga-404-section__main__wrapper"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.75, delay: 1, ease: "easeInOut" }}
                    >
                        <div className="mga-404-section__info">
                            <h1 className="mga-404-section__info__title">404</h1>
                            <p className="mga-404-section__info__text">{ strings.notfound }</p>
                            <Link to="/">{ strings.gohome }</Link>
                        </div>
                        <div className="mga-404-section__main__bottom">
                            <Social whitemode={true} />
                        </div>
                    </motion.div>
                </div>
            </Section>
        </>
    )
}

export default React.memo(NotFound)
